import React from 'react';
import logo from '../logo.svg';
import '../App.css';
import { 
  Navbar,
  Nav,
  Collapse
} from 'bootstrap-4-react';

const styles = {
  navbar: {
    padding: "10px 0px"
  }
}

function Navigation() {
  return (
      <Navbar style={styles.navbar} expand="md" dark mb="3">
          <Navbar.Brand href="#">
            <img src={logo} alt="logo" height="40"/>
          </Navbar.Brand>
          <Navbar.Toggler target="#navbarColor1" />
          <Collapse navbar id="navbarColor1">
            <Navbar.Nav ml="auto">
              <Nav.ItemLink href="#" active>Программа</Nav.ItemLink>
              <Nav.ItemLink href="#sRow">Ведущий</Nav.ItemLink>
              <Nav.ItemLink href="#aRow">О нас</Nav.ItemLink>
              <Nav.ItemLink href="#cRow">Зарегистрироваться</Nav.ItemLink>
            </Navbar.Nav>
          </Collapse>
      </Navbar>
      
  );
}

export default Navigation;